import React from 'react';
import {Routes, Route} from "react-router-dom";

//routes
import AboutUs from './pages/AboutUs'
import Landing from './pages/Landing'
import Resources from './pages/Resources'
import BecomeResources from './pages/BecomeResources'
import Layout from './layout'

const publicRoutes = [
    {path: "/", component: <Landing/>},
    {path: "/about", component: <AboutUs/>},
    {path: "/landing", component: <Landing/>},
    {path: "/resources", component: <Resources/>},
    {path: "/becomearesource", component: <BecomeResources/>},
]
const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <Layout>
                                {route.component}
                            </Layout>}
                        key={idx}
                        exact={true}
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default Index;
